import React from "react";
import Common_Title from "../../common-components/common-btn/common-title/Common_Title";
import Common_Heading from "../../common-components/common-heading/Common_Heading";
import "./Our_Journey.css";

function Our_Journey() {
  return (
    <section className="our-journey-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-5 col-xs-12">
            <div className="journey-image-container">
              <div className="red-border-accent"></div>
              <img
                src="/assets/images/about-us-banner.png"
                alt="11 Dreams Trophy"
                className="img-fluid journey-main-img"
              />
            </div>
          </div>
          <div className="col-12 col-md-5 col-xs-12">
            <div className="journey-content-wrapper">
              <Common_Title title_text="OUR JOURNEY" />
              <Common_Heading head1="ABOUT 11 DREAMS" />

              <p className="journey-description">
                Redefine the fantasy sports experience with a passion for
                cricket and a vision for accessible, fun, and secure betting. We
                bring the stadium atmosphere to your finger tips.
              </p>

              <div className="download-buttons">
                <a
                  href="https://play.google.com/store/games?device=windows"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="playstore-btn"
                >
                  <img
                    src="/assets/images/about-11-dream/google-play-btn.png"
                    alt="Get it on Google Play"
                    className="play-store-img"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Our_Journey;
